(function () {
  "use strict";

  var root = document.querySelector("[data-rof-exp]");
  if (!root) return;

  var cfgEl = document.getElementById("rof-exp-config");
  var cfg = { assetMode: "photo", product: {}, photos: {}, model: {} };
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {}

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var staticEl = root.querySelector("[data-rof-exp-static]");

  function hideAgent() {
    var host = document.getElementById("ads-agent-host");
    if (host) host.style.setProperty("display", "none", "important");
    var els = document.querySelectorAll("button, a, iframe, [role='button']");
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (root.contains(el)) continue;
      var t = ((el.getAttribute("aria-label") || "") + " " + (el.textContent || "")).toLowerCase();
      if (t.indexOf("shop with ai") !== -1 || t.indexOf("shopping agent") !== -1) {
        el.style.setProperty("display", "none", "important");
        if (el.parentElement) el.parentElement.style.setProperty("display", "none", "important");
      }
    }
  }

  hideAgent();
  if (reduced) {
    if (staticEl) staticEl.hidden = false;
    return;
  }

  var THREE;
  var gsap;
  var canvas = root.querySelector("[data-rof-exp-canvas]");
  var scrollEl = root.querySelector("[data-rof-exp-scroll]");
  var progressEl = root.querySelector("[data-rof-exp-progress]");
  var type = {
    rules: root.querySelector('[data-line="rules"]'),
    of: root.querySelector('[data-line="of"]'),
    faith: root.querySelector('[data-line="faith"]'),
    diego: root.querySelector('[data-line="diego"]'),
    velvet: root.querySelector('[data-line="velvet"]'),
    stitch: root.querySelector('[data-line="stitch"]'),
    lining: root.querySelector('[data-line="lining"]')
  };
  var endEl = root.querySelector("[data-rof-exp-end]");

  var mobile = window.matchMedia("(max-width: 749px)").matches;
  var cores = navigator.hardwareConcurrency || 4;
  var mem = navigator.deviceMemory || 4;
  var low = mobile || cores < 4 || mem <= 4;

  var film = {
    camZ: mobile ? 3.05 : 3.55,
    camY: 0.04,
    fov: mobile ? 36 : 32,
    scale: mobile ? 0.34 : 0.24,
    rotY: 0,
    rotX: 0,
    posY: 0,
    sweep: -0.1,
    front: 0,
    back: 0,
    zip: 0,
    tiger: 0,
    lining: 0,
    displace: low ? 0 : 0.035
  };

  var pointer = { x: 0, y: 0, tx: 0, ty: 0 };
  var renderer;
  var scene;
  var camera;
  var garment;
  var mats = {};
  var meshes = {};
  var running = false;

  var VERT = [
    "varying vec2 vUv;",
    "varying vec3 vN;",
    "varying vec3 vV;",
    "uniform sampler2D map;",
    "uniform float uDisplace;",
    "void main() {",
    "  vUv = uv;",
    "  float h = texture2D(map, uv).g;",
    "  float d = (0.5 - h) * uDisplace;",
    "  vec3 p = position + normal * d;",
    "  vec4 wp = modelViewMatrix * vec4(p, 1.0);",
    "  vV = -wp.xyz;",
    "  vN = normalize(normalMatrix * normal);",
    "  gl_Position = projectionMatrix * wp;",
    "}"
  ].join("\n");

  var FRAG = [
    "varying vec2 vUv;",
    "varying vec3 vN;",
    "varying vec3 vV;",
    "uniform sampler2D map;",
    "uniform float uOpacity;",
    "uniform float uSweep;",
    "uniform vec3 uLight;",
    "uniform float uClose;",
    "void main() {",
    "  vec4 tex = texture2D(map, vUv);",
    "  if (tex.a < 0.04) discard;",
    "  vec3 n = normalize(vN);",
    "  vec3 v = normalize(vV);",
    "  vec3 l = normalize(uLight);",
    "  float ndl = max(dot(n, l), 0.0);",
    "  float rim = pow(1.0 - max(dot(n, v), 0.0), 3.2);",
    "  float band = vUv.x * 0.18 + vUv.y;",
    "  float s = uSweep * 1.55 - band;",
    "  float sweep = smoothstep(0.0, 0.12, s) * (1.0 - smoothstep(0.18, 0.58, s));",
    "  vec3 col = tex.rgb;",
    "  col *= 0.72 + ndl * 0.42;",
    "  col += vec3(0.05, 0.046, 0.04);",
    "  col += sweep * vec3(1.0, 0.96, 0.88) * 0.08;",
    "  col += rim * vec3(0.94, 0.91, 0.84) * (0.28 + uClose * 0.1);",
    "  col = mix(col, col * 1.04, uClose);",
    "  gl_FragColor = vec4(col, tex.a * uOpacity);",
    "}"
  ].join("\n");

  var DETAIL_FRAG = [
    "varying vec2 vUv;",
    "uniform sampler2D map;",
    "uniform float uOpacity;",
    "uniform float uSweep;",
    "void main() {",
    "  vec4 tex = texture2D(map, vUv);",
    "  float band = vUv.y;",
    "  float s = uSweep * 1.4 - band;",
    "  float sweep = smoothstep(0.0, 0.1, s) * (1.0 - smoothstep(0.12, 0.4, s));",
    "  vec3 col = tex.rgb * (0.94 + sweep * 0.08);",
    "  gl_FragColor = vec4(col, uOpacity);",
    "}"
  ].join("\n");

  function setColorSpace(tex) {
    if ("colorSpace" in tex && THREE.SRGBColorSpace) tex.colorSpace = THREE.SRGBColorSpace;
    else if (THREE.sRGBEncoding) tex.encoding = THREE.sRGBEncoding;
    tex.minFilter = THREE.LinearMipmapLinearFilter;
    tex.magFilter = THREE.LinearFilter;
    tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
    tex.needsUpdate = true;
    return tex;
  }

  function loadTexture(url) {
    return new Promise(function (resolve, reject) {
      new THREE.TextureLoader().load(url, resolve, undefined, reject);
    });
  }

  function makeMat(map, close) {
    return new THREE.ShaderMaterial({
      uniforms: {
        map: { value: map },
        uOpacity: { value: 0 },
        uSweep: { value: 0 },
        uLight: { value: new THREE.Vector3(0.45, 0.55, 0.85) },
        uClose: { value: close || 0 },
        uDisplace: { value: 0 }
      },
      vertexShader: VERT,
      fragmentShader: FRAG,
      transparent: true,
      depthWrite: false
    });
  }

  function makeDetail(map) {
    return new THREE.ShaderMaterial({
      uniforms: {
        map: { value: map },
        uOpacity: { value: 0 },
        uSweep: { value: 0.4 }
      },
      vertexShader: [
        "varying vec2 vUv;",
        "void main(){ vUv = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0); }"
      ].join("\n"),
      fragmentShader: DETAIL_FRAG,
      transparent: true,
      depthWrite: false
    });
  }

  function fallback() {
    running = false;
    if (staticEl) staticEl.hidden = false;
    if (canvas) canvas.style.display = "none";
  }

  function fitDetail(mesh) {
    if (!camera) return;
    var dist = Math.abs(camera.position.z - mesh.position.z);
    var h = 2 * Math.tan((camera.fov * Math.PI) / 360) * dist;
    var w = h * (camera.aspect || 1);
    mesh.scale.set(w * 1.04, h * 1.04, 1);
  }

  async function loadPhotos() {
    var p = cfg.photos || {};
    var front = setColorSpace(await loadTexture(p.front));
    var back = setColorSpace(await loadTexture(p.back));
    var zip = setColorSpace(await loadTexture(p.details.zip));
    var tiger = setColorSpace(await loadTexture(p.details.tiger));
    var lining = setColorSpace(await loadTexture(p.details.lining));

    var segs = low ? 16 : 48;
    var geo = new THREE.PlaneGeometry(1.62, 1.62, segs, segs);
    mats.front = makeMat(front, 0);
    mats.back = makeMat(back, 0);
    mats.zip = makeDetail(zip);
    mats.tiger = makeDetail(tiger);
    mats.lining = makeDetail(lining);

    garment = new THREE.Group();
    meshes.front = new THREE.Mesh(geo, mats.front);
    meshes.back = new THREE.Mesh(geo, mats.back);
    meshes.back.position.z = -0.012;
    garment.add(meshes.front, meshes.back);
    scene.add(garment);

    var dgeo = new THREE.PlaneGeometry(1, 1);
    meshes.zip = new THREE.Mesh(dgeo, mats.zip);
    meshes.tiger = new THREE.Mesh(dgeo, mats.tiger);
    meshes.lining = new THREE.Mesh(dgeo, mats.lining);
    meshes.zip.position.z = 0.42;
    meshes.tiger.position.z = 0.4;
    meshes.lining.position.z = 0.38;
    scene.add(meshes.zip, meshes.tiger, meshes.lining);
  }

  async function loadModel() {
    if (!cfg.model || !cfg.model.url) throw new Error("no-model");
    throw new Error("model-mode-requires-glb");
  }

  function buildTimeline() {
    gsap.set([type.rules, type.of, type.faith, type.diego, type.velvet, type.stitch, type.lining], {
      opacity: 0
    });
    gsap.set(endEl, { xPercent: -50, y: 22, opacity: 0 });

    var tl = gsap.timeline({
      defaults: { ease: "none" },
      scrollTrigger: {
        trigger: scrollEl,
        start: "top top",
        end: "bottom bottom",
        scrub: 1.2,
        onUpdate: function (self) {
          if (progressEl) progressEl.style.width = self.progress * 100 + "%";
          root.classList.toggle("is-moving", self.progress > 0.04);
          root.classList.toggle("is-end", self.progress > 0.9);
        }
      }
    });

    tl.fromTo(
      film,
      { front: 0, scale: mobile ? 0.28 : 0.2, camZ: mobile ? 3.55 : 4.25, sweep: -0.18 },
      { front: 1, scale: mobile ? 0.72 : 0.62, camZ: mobile ? 2.72 : 3.02, sweep: 0.42, duration: 1.2 },
      0.12
    );
    tl.to(film, { rotY: 0.038, rotX: -0.016, duration: 0.85 }, 0.55);
    tl.to(type.rules, { opacity: 0.42, duration: 0.36 }, 0.62);
    tl.to(type.rules, { opacity: 0, duration: 0.28 }, 1.04);
    tl.to(type.of, { opacity: 0.5, duration: 0.3 }, 0.92);
    tl.to(type.of, { opacity: 0, duration: 0.24 }, 1.24);
    tl.to(type.faith, { opacity: 0.38, duration: 0.32 }, 1.14);
    tl.to(type.faith, { opacity: 0, duration: 0.28 }, 1.48);
    tl.to(film, { scale: mobile ? 1.02 : 0.9, camZ: 2.32, fov: 28, posY: 0.05, sweep: 0.7, duration: 0.55 }, 1.45);
    tl.to(type.diego, { opacity: 0.62, duration: 0.24 }, 1.5);
    tl.to(type.diego, { opacity: 0, duration: 0.2 }, 1.82);
    tl.to(film, { scale: mobile ? 1.45 : 1.52, camZ: 1.68, fov: 24, posY: 0.14, duration: 0.42 }, 1.88);
    tl.to(film, { front: 0, duration: 0.16 }, 2.06);
    tl.to(film, { zip: 1, duration: 0.26 }, 2.16);
    tl.to(type.velvet, { opacity: 1, duration: 0.16 }, 2.2);
    tl.to(type.velvet, { opacity: 0, duration: 0.14 }, 2.52);
    tl.to(film, { zip: 0, duration: 0.14 }, 2.56);
    tl.to(film, { tiger: 1, duration: 0.24 }, 2.66);
    tl.to(type.stitch, { opacity: 1, duration: 0.16 }, 2.68);
    tl.to(type.stitch, { opacity: 0, duration: 0.14 }, 3.08);
    tl.to(film, { tiger: 0, duration: 0.14 }, 3.1);
    tl.to(film, { lining: 1, duration: 0.24 }, 3.2);
    tl.to(type.lining, { opacity: 1, duration: 0.16 }, 3.22);
    tl.to(type.lining, { opacity: 0, duration: 0.16 }, 3.72);
    tl.to(film, { lining: 0, duration: 0.18 }, 3.74);
    tl.to(
      film,
      {
        front: 0,
        back: 1,
        scale: mobile ? 0.7 : 0.58,
        camZ: mobile ? 2.85 : 3.08,
        fov: 32,
        posY: 0.02,
        rotY: -0.024,
        duration: 0.5
      },
      3.9
    );
    tl.to(film, { sweep: 0.78, duration: 0.36 }, 3.94);
    tl.to(film, { back: 0, front: 1, rotY: 0.016, scale: mobile ? 0.82 : 0.72, camZ: 2.95, duration: 0.44 }, 4.36);
    tl.to(endEl, { opacity: 1, y: 0, duration: 0.32 }, 4.5);

    return tl;
  }

  function applyFilm() {
    if (!camera || !garment) return;
    camera.position.z = film.camZ;
    camera.position.y = film.camY + pointer.y * 0.04;
    camera.position.x = pointer.x * 0.05;
    camera.fov = film.fov;
    camera.updateProjectionMatrix();
    camera.lookAt(0, 0.02, 0);

    garment.scale.setScalar(film.scale);
    garment.position.y = film.posY;
    garment.rotation.y = film.rotY + pointer.x * 0.052;
    garment.rotation.x = film.rotX + pointer.y * -0.03;

    var light = mats.front.uniforms.uLight.value;
    light.set(0.35 + pointer.x * 0.45, 0.5 - pointer.y * 0.25, 0.85);

    mats.front.uniforms.uOpacity.value = film.front;
    mats.back.uniforms.uOpacity.value = film.back;
    mats.front.uniforms.uSweep.value = film.sweep;
    mats.back.uniforms.uSweep.value = film.sweep;
    mats.front.uniforms.uDisplace.value = film.displace;
    mats.back.uniforms.uDisplace.value = film.displace * 0.6;
    mats.front.uniforms.uLight.value.copy(light);
    mats.back.uniforms.uLight.value.copy(light);
    mats.front.uniforms.uClose.value = film.zip + film.tiger * 0.4;
    mats.zip.uniforms.uOpacity.value = film.zip;
    mats.tiger.uniforms.uOpacity.value = film.tiger;
    mats.lining.uniforms.uOpacity.value = film.lining;
    mats.zip.uniforms.uSweep.value = film.sweep;
    mats.tiger.uniforms.uSweep.value = film.sweep;
    mats.lining.uniforms.uSweep.value = film.sweep;

    fitDetail(meshes.zip);
    fitDetail(meshes.tiger);
    fitDetail(meshes.lining);
    meshes.zip.scale.multiplyScalar(1.02 + film.zip * 0.08);
    meshes.tiger.scale.multiplyScalar(1.02 + film.tiger * 0.08);
    meshes.lining.scale.multiplyScalar(1.02 + film.lining * 0.08);
  }

  function tick() {
    if (!running) return;
    pointer.x += (pointer.tx - pointer.x) * 0.06;
    pointer.y += (pointer.ty - pointer.y) * 0.06;
    applyFilm();
    renderer.render(scene, camera);
    requestAnimationFrame(tick);
  }

  function onPointer(e) {
    if (e.pointerType === "touch") return;
    pointer.tx = (e.clientX / window.innerWidth) * 2 - 1;
    pointer.ty = (e.clientY / window.innerHeight) * 2 - 1;
  }

  function onResize() {
    if (!renderer || !camera) return;
    var w = window.innerWidth;
    var h = window.innerHeight;
    var dpr = Math.min(window.devicePixelRatio || 1, low ? 1.15 : 1.6);
    renderer.setPixelRatio(dpr);
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  }

  async function init() {
    try {
      renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        alpha: true,
        antialias: !low,
        premultipliedAlpha: false,
        powerPreference: low ? "low-power" : "high-performance",
        stencil: false,
        depth: true
      });
    } catch (err) {
      fallback();
      return;
    }

    if (!renderer.getContext()) {
      fallback();
      return;
    }

    renderer.setClearColor(0x000000, 0);
    renderer.toneMapping = THREE.NoToneMapping;
    if (THREE.SRGBColorSpace && "outputColorSpace" in renderer) {
      renderer.outputColorSpace = THREE.SRGBColorSpace;
    } else if (THREE.sRGBEncoding) {
      renderer.outputEncoding = THREE.sRGBEncoding;
    }

    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(film.fov, window.innerWidth / window.innerHeight, 0.05, 20);
    camera.position.set(0, 0.04, film.camZ);

    try {
      if (cfg.assetMode === "model") await loadModel();
      else await loadPhotos();
    } catch (err) {
      try {
        await loadPhotos();
      } catch (err2) {
        fallback();
        return;
      }
    }

    onResize();
    buildTimeline();
    window.addEventListener("pointermove", onPointer, { passive: true });
    window.addEventListener("resize", onResize, { passive: true });
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) running = false;
      else if (!running) {
        running = true;
        tick();
      }
    });

    running = true;
    tick();
    hideAgent();
    if (window.MutationObserver) {
      new MutationObserver(hideAgent).observe(document.body, { childList: true, subtree: true });
    } else {
      setInterval(hideAgent, 2000);
    }
  }

  function boot() {
    hideAgent();
    var n = 0;
    (function wait() {
      if (window.THREE && window.gsap && window.ScrollTrigger) {
        THREE = window.THREE;
        gsap = window.gsap;
        gsap.registerPlugin(window.ScrollTrigger);
        init();
      } else if (++n < 60) {
        setTimeout(wait, 50);
      } else if (staticEl) {
        staticEl.hidden = false;
      }
    })();
  }

  boot();
})();
